/**
 * Resolves EPC EST3 approval deep links (entity_id = estimate revision id)
 * to Bid Control Room → Estimate with Approval panel open.
 */
import React, { useEffect, useState } from 'react';
import { Alert, Spin } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { epcEstimationService } from '@/services/epcEstimation.service';

const EpcEstimateRevisionBridgePage: React.FC = () => {
  const { revisionId = '' } = useParams<{ revisionId: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        if (!revisionId) throw new Error('Missing revision id');
        const ctx = await epcEstimationService.getRevisionContext(revisionId);
        const tenderId = String(ctx?.tender_id || '');
        if (!tenderId) throw new Error('Estimate has no tender link');
        if (cancelled) return;
        navigate(
          `/epc/commercial/tenders/${encodeURIComponent(tenderId)}/bid?tab=estimate&leaf=approval&revision=${encodeURIComponent(revisionId)}`,
          { replace: true }
        );
      } catch (e: unknown) {
        if (cancelled) return;
        const err = e as { response?: { data?: { message?: string } }; message?: string };
        setError(err?.response?.data?.message || err?.message || 'Could not open estimate approval');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [revisionId, navigate]);

  if (error) {
    return (
      <div style={{ padding: 24 }}>
        <Alert type="error" showIcon message={error} />
      </div>
    );
  }

  return (
    <div style={{ padding: 48, textAlign: 'center' }}>
      <Spin size="large" tip="Opening estimate approval…" />
    </div>
  );
};

export default EpcEstimateRevisionBridgePage;
